import { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import LoadScreen from "../UI/LoadScreen";
import { useForm } from "react-hook-form"
import {
    useDeleteProductPhotoMutation,
    useGetProductParamsQuery,
    useGetProductQuery,
    usePostProductPhotoMutation,
    usePutProductMutation
} from "../../features/CallApi";
import { useParams, useNavigate } from 'react-router-dom';
// import { useEffect } from "react";
// import { withMask, withHookFormMask } from 'use-mask-input';

export const ProductEdit = ({ refetch }) => {

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, data: productParams } = useGetProductParamsQuery();
    const { isLoading: productisLoading, data: product, error, refetch: refetchProduct } = useGetProductQuery(id)
    const [putProduct, { isLoading: putIsloading }] = usePutProductMutation();
    const [requiredSNInput, setRequiredSNInput] = useState(false);
    const [inActive, setInActive] = useState();
    const [postProductPhoto, { isLoading: postingPhoto }] = usePostProductPhotoMutation();
    const [deleteProductPhoto, ] = useDeleteProductPhotoMutation();
    const [changingPhoto, setChangingPhoto] = useState();

    const onImageChange = (event) => {
        setChangingPhoto(true)
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader(event.target.files[0]);
            reader.onloadend = () => {
                const body = {
                    id: id,
                    photo: reader.result,
                    photoType: event.target.files[0].type
                }
                postProductPhoto({ id, ...body })
            }
            reader.readAsDataURL(event.target.files[0])
        }
        setTimeout(() => {
            refetchProduct()
            setChangingPhoto(false)
        }, 2000)
    }
    const deletePhoto = () => {
        setChangingPhoto(true)
        deleteProductPhoto(id)
        setTimeout(() => {
            refetchProduct()
            setChangingPhoto(false)
        }, 2000)
        
    }

    const onRequiredSNChenge = (e) => {
        setRequiredSNInput(e.target.checked)
    }
    const onInActiveChenge = (e) => {
        setInActive(e.target.checked)
    }

    useEffect(() => {refetchProduct()},[])

    useEffect(() => {
        { product && setRequiredSNInput(product.requiredSN) }
        { product && setInActive(product.inActive) }

    }, [product])
  
    const setPutProduct = (data) => {
        data.requiredSN = requiredSNInput
        data.inActive = inActive
        putProduct(data).unwrap().then((e) => {
            navigate(`/admin/products`)
        }
        ).catch((e) => {
            console.log(e)
        })
    }

    return (
        <div>
            {productisLoading || putIsloading ? <LoadScreen></LoadScreen> : <div>
                {product && product.length > 0 ? <h1>{error}</h1> : <div>
                    {isLoading ? <LoadScreen></LoadScreen> :
                        <form onSubmit={handleSubmit(setPutProduct)}>
                            <input hidden value={product.id} {...register("id", {})} />
                            {productParams ?
                                <div className="row">
                                    <div className="col-xl">
                                        <div className="mb-1">
                                            <label htmlFor="categoryId" className="form-label">Категория</label>
                                            <select id="categoryId" name="categoryId" defaultValue={product.category.id} className="form-select" placeholder={`Выберите категорию`}
                                                {...register("categoryId", { required: { value: true, message: "Выберите категорию" } })} >
                                                {productParams.category ?
                                                    productParams.category.map(category =>
                                                        <option key={category.id} value={category.id}>{category.name}</option>
                                                    ) : <option disabled>Нет доступных категорий</option>}
                                            </select>
                                            {errors.categoryId && <span className='text-danger'>{errors.category?.message}</span>}
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="agent" className="form-label">Агент</label>
                                            <select id="agentId" name="agentId" defaultValue={(product.agent && product.agent.id)} className="form-select"
                                                {...register("agentId")} >
                                                <option value="0">--- Агент не выбран ---</option>
                                                {productParams.agent ?
                                                    productParams.agent.map(agent =>
                                                        <option key={agent.id} value={agent.id}>{agent.name} (ИНН: {agent.tin})</option>
                                                    ) : <option disabled>Нет доступных агентов</option>}
                                            </select>
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="name" className="form-label">Наименование</label>
                                            <input id="name" defaultValue={product.name} name="name" className="form-control"
                                                {...register("name", { required: { value: true, message: "Укажите наименование" } })} />
                                            {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="sku" className="form-label">Артикул</label>
                                            <input id="sku" name="sku" className="form-control" defaultValue={product.sku}
                                                {...register("sku", { required: { value: true, message: "Укажите артикул" } })} />
                                            {errors.sku && <span className='text-danger'>{errors.sku?.message}</span>}
                                        </div>
                                        <div className="mb-1">
                                            <label htmlFor="price" className="form-label">Цена</label>
                                            <input id="price" defaultValue={product.price} name="price" step={.01} type={"number"} className="form-control"
                                                {...register("price", { required: { value: true, message: "Укажите цену" } })} />
                                            {errors.price && <span className='text-danger'>{errors.price?.message}</span>}
                                        </div>
                                        <div className="row mb-1">
                                            <div className="col-md">
                                                <div className="mb-1">
                                                    <label htmlFor="typeProduct" className="form-label">Тип продукта</label>
                                                    <select id="typeProduct" defaultValue={product.typeProduct} name="typeProduct" className="form-select"
                                                        {...register("typeProduct")} >
                                                        {productParams.typeProduct ?
                                                            productParams.typeProduct.map(typeProduct =>
                                                                <option key={typeProduct.id} value={typeProduct.id}>{typeProduct.name}</option>
                                                            ) : <option disabled>Нет доступных категорий</option>}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md">
                                                <div className="mb-1">
                                                    <label htmlFor="taxProduct" className="form-label">Налоговая ставка</label>
                                                    <select id="taxProduct" defaultValue={product.taxProduct} name="taxProduct" className="form-select"
                                                        {...register("taxProduct")} >
                                                        {productParams.taxProduct ?
                                                            productParams.taxProduct.map(taxProduct =>
                                                                <option key={taxProduct.id} value={taxProduct.id}>{taxProduct.name}</option>
                                                            ) : <option disabled>Нет доступных категорий</option>}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md">
                                                <div className="mb-1">
                                                    <label htmlFor="calculationMethod" className="form-label">Метод расчета</label>
                                                    <select id="calculationMethod" defaultValue={product.calculationMethod} name="calculationMethod" className="form-select"
                                                        {...register("calculationMethod")} >
                                                        {productParams.calculationMethod ?
                                                            productParams.calculationMethod.map(calculationMethod =>
                                                                <option key={calculationMethod.id} value={calculationMethod.id}>{calculationMethod.name}</option>
                                                            ) : <option disabled>Нет доступных категорий</option>}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-2 d-flex">
                                            <div className=" form-check form-switch">
                                                <label className="form-check-label">Отключен</label>
                                                <input defaultChecked={product.inActive} onClick={(e) => onInActiveChenge(e)} type="checkbox"
                                                    className="form-check-input check-input-lc" {...register("inActive")} />
                                            </div>
                                        </div>
                                        <div className="mb-2 d-flex">
                                            <div className=" form-check form-switch">
                                                <label className="form-check-label">Требует серийный номер</label>
                                                <input defaultChecked={product.requiredSN} onClick={(e) => onRequiredSNChenge(e)} type="checkbox"
                                                    className="form-check-input check-input-lc" {...register("requiredSN")} />
                                            </div>
                                        </div>
                                        <div className={`mb-1 ${requiredSNInput ? "" : "d-none"}`}>
                                            <label htmlFor="maskSN" className="form-label">Маска серийного номера</label>
                                            <input defaultValue={product.maskSN} id="maskSN" name="maskSN" type="text" className="form-control"
                                                {...register("maskSN")} />
                                            {errors.maskSN && <span className='text-danger'>{errors.maskSN?.message}</span>}
                                        </div>
                                    </div>
                                    <div className="col-xl">
                                        <label htmlFor="image" className="form-label">Изображение продукта</label>
                                        <div className="card mb-3">
                                            {postingPhoto || changingPhoto ? <LoadScreen /> :
                                                <div className="mb-3 text-center">
                                                    <img key={Date.now()} src={product.imageType ? `/api/products/photo/${product.id}` : `/Content/img/NoPhoto.png`} className="img-fluid" alt="Product photo" />
                                                </div>
                                            }
                                        </div>
                                        <div className='input-group'>

                                            {product.imageType &&
                                                <Button size='sm' color='danger' onClick={() => deletePhoto()}>Удалить Изображение</Button>
                                            }
                                            <input onChange={(e) => onImageChange(e)}
                                                id="photo"
                                                name="photo"
                                                className="form-control form-control-sm"
                                                accept=".jpg, .jpeg, .png" type="file" />
                                        </div>
                                    </div>
                                </div> : <LoadScreen />
                            }
                            <ButtonGroup className='mt-3'>
                                <Button color="success">
                                    Сохранить
                                </Button>
                                <Button color="warning" onClick={() => navigate('/admin/products')}>
                                    Отмена
                                </Button>
                            </ButtonGroup>
                        </form>
                    }
                </div>
                }
            </div>}
        </div>
    )
}